import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from '../mui/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import UploadFilesListItem from "./UploadFilesListItem";
import { FileInfo } from "./FileInfo";

export interface UploadFilesListProps {
    files: Array<FileInfo>;
    removeFile: (index: FileInfo) => void;
    uploading: boolean;
    allowedExtensions: string[];
}


type PropsType = UploadFilesListProps & WithStyles<typeof styles>;


class UploadFilesList extends React.PureComponent<PropsType> {

    render() {
        const { files, removeFile, allowedExtensions, classes } = this.props;
        return <div className={classes.root}>
            <Table padding="checkbox">
                <TableBody>
                    {files.map((v, k) => <UploadFilesListItem key={k} fileInfo={v} removeFile={removeFile} allowedExtensions={allowedExtensions} />)}
                </TableBody>

            </Table>
        </div>;
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        marginLeft: -2 * theme.spacing.unit,
        marginRight: -2 * theme.spacing.unit,
        marginTop: -2 * theme.spacing.unit,
        marginBottom: 2 * theme.spacing.unit,

    },
});

export default withStyles(styles)(UploadFilesList);